import React, { useCallback, useEffect, useState } from "react";
import "./Dashboard.css";
import { GetDashboardStats } from "../../DAL/fetch";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { formatNumber } from "../../Utils/formatNumber";

const Dashboard = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const headCells = [
    { id: "status", numeric: false, label: "" },
    { id: "id", numeric: false, label: "ID" },
    { id: "subject", numeric: false, label: "Subject" },
    { id: "requester", numeric: false, label: "Requester" },
    { id: "channel", numeric: false, label: "Channel" },
    { id: "type", numeric: false, label: "Type" },
    { id: "assignee", numeric: false, label: "Assignee" },
    { id: "date", numeric: false, label: "Date" },
  ];
  const title = "Unassigned";
  const title2 = "Assigned";

  const user = JSON.parse(localStorage.getItem("user"));
  const permissions = user?.permissions || [];

  // Agar permission list me "dashboard" nahi hai
  const hasDashboardAccess =
    permissions.length === 0 ||
    permissions.some((p) => p.name?.toLowerCase() === "dashboard");
  const GetStatistics = useCallback(async () => {
    if (!hasDashboardAccess) return;
    setLoading(true);
    const resp = await GetDashboardStats();
    if (resp?.status == 200) {
      setData(resp?.data);
      setLoading(false);
    }
  }, []);

  const handleNavigate = (route) => {
    navigate(route);
  };

  useEffect(() => {
    GetStatistics();
  }, []);

  if (!hasDashboardAccess) {
    return (
      <div className="Dashboard">
        <div>
          <h2 style={{ color: "#1976d2", marginBottom: "10px" }}>
            👋 Welcome to Our Dashboard!
          </h2>
        </div>
      </div>
    );
  }
  return (
    <div className="Dashboard">
      <div className="dashboard-headings">
        <p>Dashboard</p>
      </div>
      <div className="cards">
        <div
          className="dashboard-card"
          style={{ cursor: "default" }}
          // onClick={() => handleNavigate("host-level-list")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.host)}</h3>
          )}
          <p>Total Hosts</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/users")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.visitor)}</h3>
          )}
          <p>Total Visitors</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/banned-user")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.banned)}</h3>
          )}
          <p>Total Banned Users</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/products")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.products)}</h3>
          )}
          <p>Total Products</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/giftlist")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.gifts)}</h3>
          )}
          <p>Total Gifts</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/family-list/Active")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.families)}</h3>
          )}
          <p>Total Families</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/family-list/Pending")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.pending_families)}</h3>
          )}
          <p>Total Pending Families</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/family-list/Active")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.approved_families)}</h3>
          )}
          <p>Total Approved Families</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/family-list/Blocked")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.rejected_families)}</h3>
          )}
          <p>Total Rejected Families</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/moments-pending")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.image_moments)}</h3>
          )}
          <p>Total Image Moments</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/moments-pending")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.pending_image_moments)}</h3>
          )}
          <p>Total Pending Image Moments</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/moments-approve")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.approved_image_moments)}</h3>
          )}
          <p>Total Approved Image Moments</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/moments-rejected")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.rejected_image_moments)}</h3>
          )}
          <p>Total Rejected Image Moments</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/pending-video-moments")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.video_moments)}</h3>
          )}
          <p>Total Video Moments</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/pending-video-moments")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.pending_video_moments)}</h3>
          )}
          <p>Total Pending Video Moments</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/approve-video-moments")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.approved_video_moments)}</h3>
          )}
          <p>Total Approved Video Moments</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/reject-video-moments")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.rejected_video_moments)}</h3>
          )}
          <p>Total Rejected Video Moments</p>
        </div>

        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/agencylist")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.agencies)}</h3>
          )}
          <p>Total Agencies</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/product-categories")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.categories)}</h3>
          )}
          <p>Total Categories</p>
        </div>

        <div className="dashboard-card" onClick={() => handleNavigate("/pk")}>
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.pk)}</h3>
          )}
          <p>Total Sceduled Pk</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/merchant")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.merchants)}</h3>
          )}
          <p>Total Merchants</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/reseller-list")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.resellers)}</h3>
          )}
          <p>Total Resellers</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/all-banners")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.banners)}</h3>
          )}
          <p>Total Banners</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => handleNavigate("/customer-list")}
        >
          {loading == true ? (
            <CircularProgress size={20} />
          ) : (
            <h3>{formatNumber(data?.customerSupport)}</h3>
          )}
          <p>Total Customer Support</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
